import { RESET_STATE, UPDATE_STATE_PARAMS } from './SearchProgressModalConstants';

export const initialState = {
  priorityWatcher: null,
  searchId: '',
  requestId: '',
  queries: {},
  queryFactItem: null,
};

// eslint-disable-next-line default-param-last
export default function searchProgressReducer(state = initialState, action) {
  switch (action.type) {
    case RESET_STATE: {
      return initialState;
    }
    case UPDATE_STATE_PARAMS: {
      return {
        ...state,
        ...action.params,
      };
    }
    default: {
      return state;
    }
  }
}
